<template>
    <div class="al-content">
        <div class="content-top">
            <div class="text-center clearfix">
                <h3 class="al-title ">USER SETTING</h3>
            </div>
        </div>


        <div>
            <div class="panel panel-blur with-scroll animated zoomIn" style="max-width:800px; margin:auto">
                <div class="panel-heading clearfix">
                    <h5 class="panel-title">Password</h5>
                </div>
                <div class="panel-body">
                    <div>
                        <form class="form-horizontal">
                            <div class="form-group row">
                                <label for="Name" class="col-sm-3 control-label">New Password</label>
                                <div class="col-sm-9">
                                    <input type="password" class="form-control mb-3" v-model="password" id="password" @keyup="passwordCheck" />
                                    <i class="ion-alert-circled form-control-feedback"></i>
                                    <span class="help-block red-text basic-block"></span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="Name" class="col-sm-3 control-label">Confirm Password</label>
                                <div class="col-sm-9">
                                    <input type="password" class="form-control mb-3" v-model="ConfirmPassword" id="confirmpassword" @keyup="passwordCheck" />
                                    <i class="ion-alert-circled form-control-feedback"></i>
                                    <span class="help-block red-text basic-block"></span>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="panel-heading clearfix">
                    <h5 class="panel-title">Email  & TimeZone</h5>
                </div>
                <div class="panel-body">
                    <div>
                        <form class="form-horizontal">
                            <div class="form-group row">
                                <label for="Name" class="col-sm-3 control-label">Email</label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control mb-1" v-model="email" id="Email" @keyup="validateCheck"/>
                                    <i class="ion-alert-circled form-control-feedback"></i>
                                    <span class="help-block red-text basic-block"></span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="Name" class="col-sm-3 control-label">TimeZone</label>
                                <div class="col-sm-9">
                                    <div id="SettingTimeZone">                                  
                                        <select id="TimeZone" class="form-control" data-live-search="true" v-model="TimeZone" data-placeholder="Select Timezone" required style="background: transparent; color: white; " >
                                            <option></option>
                                            <option v-for="timeZone in timeZones" :value="timeZone.text" :key="timeZone.text">
                                                {{ timeZone.text }}
                                            </option>
                                        </select>
                                        <div v-if="TimeZone || TimeZone.length===0" id="validationTimeZoneFeedback" class="invalid-feedback">
                                            Please select a Time Zone.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="panel-body">
                    <div>
                        <form class="form-horizontal">
                            <div class="form-group row">
                                <label class="col-sm-4 control-label"></label>
                                <div class="col-sm-2">
                                    <button class="btn btn-primary" @click.prevent="save" :disabled="!isEdit">Save</button>
                                </div>
                                <div class="col-sm-2">
                                    <button class="btn btn-danger ml-3" @click.prevent="$router.push('User')">Cancel</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import $ from 'jquery'
    /*import _ from 'lodash'*/
    import { mapState, mapActions } from 'vuex'

    //TimeZone and select2
    import moment from 'moment-timezone';
    import "select2/dist/css/select2.css"
    import "select2/dist/js/select2.min.js"
    import "select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.css"


    export default {
        name: `UserSetting`,
        data: function () {
            return {
                isEdit: false,             
                idEdit: 0,
                token: '',
                user: [],
                isValidatePass: true,
                isValidEmail: true,


                //for Edit
               
                password: '',
                ConfirmPassword: '',               
                email: '',               
                TimeZone: '',
                timeZones: [],             
               
            }
        },

        computed: mapState({
            isCheckedLogin: state => state.view.isCheckedLogin,
            groups: state => state.user.groups,
            editId: state => state.user.editId,
            index: state => state.user.index,
        }),
        methods: {
            ...mapActions({
                'loading': 'view/setLoading',
                'showModal': 'view/showModal',
                'showToast': 'view/showToast',
                'call': 'api/call'
            }),

            checkAcl(action) {
                return this.$store.state.session.acl.includes("User/" + action);
            },
            checkFullAcl(router) {
                return this.$store.state.session.acl.includes(router);
            },

            passwordCheck() {
                var passEl = document.getElementById('password');
                var passConfirmEl = document.getElementById('confirmpassword');
                if (passEl.value != passConfirmEl.value) {                      
                    $('#confirmpassword').addClass('is-invalid');
                    $('#confirmpassword').removeClass('is-valid');
                    $('#password').removeClass('is-valid');                    
                    this.isValidatePass = false;
                } else {                    
                    $('#confirmpassword').removeClass('is-invalid');
                    $('#confirmpassword').addClass('is-valid');
                    $('#password').addClass('is-valid');
                    this.isValidatePass = true;
                }

                if (passEl.value.trim() == '' && passConfirmEl.value.trim() == '') {
                    $('#password').removeClass('is-valid');
                    $('#confirmpassword').removeClass('is-valid');
                    $('#password').removeClass('is-invalid');
                    $('#confirmpassword').removeClass('is-invalid');
                }
                this.validateCheck();
            },

            validateCheck() {
                this.validEmailId();
                this.TimeZone = $('#TimeZone').val();
                this.isEdit = ((this.email !== this.user.Email || this.TimeZone !== this.user.TimeZone || this.password !== '') && this.isValidEmail);
            },

            validEmailId() {
                this.isValidEmail = this.validTextField(this.email, 'Email', true, /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/, 'Email not valid', 3, 50, this.email);               
            },

            validTextField(value, id, required, regex, regexMessage, minlen, maxlen, NameExisted, editedId) {
                if (!id || id == '') return;
                let error = "";
                minlen = minlen || 0;
                maxlen = maxlen || 1000;
                editedId = editedId || 0;
                const checkedvalue = value.trim();
                const isCheckRequire = required || (!required && checkedvalue.length > 0);

                if (required && checkedvalue == '') {
                    error = "Please input this field!";
                }
                //check name existed
                else if (NameExisted != null && NameExisted != undefined &&
                    (NameExisted[checkedvalue] != undefined && editedId != NameExisted[checkedvalue] || (Array.isArray(NameExisted) && NameExisted.includes(checkedvalue)))
                ) {
                    error = id + " is duplicated!";
                }
                //check pattern
                else if (isCheckRequire && regex != null && regex != undefined && !regex.test(checkedvalue))
                    error = regexMessage || `Invalid ${id}!`;
                //check len

                else if (isCheckRequire && (checkedvalue.length < minlen)) {
                    error = `Please input at least ${minlen} characters!`;
                }
                else if (checkedvalue.length > maxlen) {
                    error = `Please do not exceed ${maxlen} characters!`;
                }

                //return value
                if (error == '') {
                    if ($('#' + id).length > 0) {
                        $('#' + id).removeClass('is-invalid');
                        $('#' + id).addClass('is-valid');
                    }
                    return true;
                } else {
                    if ($('#' + id).length > 0) {
                        $('#' + id + '~.has-feedback').innerHTML = error;
                        $('#' + id).addClass('is-invalid');
                        $('#' + id).removeClass('is-valid');
                    }
                    $('#' + id).focus();
                    return false;
                }
            },

            async start() {
                this.token = this.$store.state.session.token;
                await this.getUserInfor();
                this.getTimeZones();
                const vm = this;
                $('#TimeZone').select2({
                    theme: "bootstrap-5",
                }).on('change', function () {
                    vm.validateCheck();
                });
            },

            getTimeZones() {

                //Get TimeZone list data
                const timeZones = moment.tz.names().map(timezone => {
                    const zoneInfo = moment.tz.zone(timezone);
                    const offsetMinutes = zoneInfo.utcOffset(new Date());
                    const offsetSign = offsetMinutes >= 0 ? '-' : '+';
                    const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);

                    const formattedOffset = `GMT${offsetSign}${String(offsetHours)}`;
                    /*const formattedOffset = `GMT ${offsetSign}${String(offsetHours).padStart(2, '0')}:${String(Math.abs(offsetMinutes) % 60).padStart(2, '0')}`;*/

                    return {
                        id: zoneInfo,
                        text: `${zoneInfo.name} ${formattedOffset}`,
                        abbreviation: zoneInfo.abbr(new Date()),
                        offset: zoneInfo.utcOffset(new Date()),
                    };
                });

                timeZones.sort((b, a) => a.offset - b.offset);
                this.timeZones = timeZones;
            },

            async getUserInfor() {
                this.loading(true);
                const rs = await this.call({ Action: 'User/GetUserInfor', Object: { Token: this.token } });
                this.loading(false);
                this.error = rs.Error;
                if (rs.Error != "") {
                    this.showModal({ isShow: true, title: 'Error', content: rs.Error, type: 'error' });
                    //no permission
                    if (rs.Error.includes("Permission Denied")) {
                        window.history.back();
                    }
                } else {
                    this.user = rs.Data;
                    this.email = this.user.Email;
                    if (this.user.TimeZone != null) //check TimeZone data null will left it at default (not selected)
                        this.TimeZone = this.user.TimeZone;
                }
            },

            async save() {

                var passEl = document.getElementById('password');
                var emailEl = document.getElementById('Email');
                this.TimeZone = $('#TimeZone').val();


                if (passEl.value.trim() != null && !this.isValidatePass)
                    return;

                if (emailEl.value.trim() == null || emailEl.value.trim() == '') {
                    this.showModal({ isShow: true, title: 'Error', content: 'Please input Email', type: 'error' });
                    return;
                }

                if (this.TimeZone == '' || this.TimeZone == null) {
                    this.showModal({ isShow: true, title: 'Error', content: 'Please input TimeZone', type: 'error' });
                    return;
                }

                this.loading(true);
                const rs = await this.call({ Action: 'User/SaveUserSetting', Object: { Id: this.user.Id, Password: passEl.value, Email: emailEl.value, TimeZone: this.TimeZone } });
                this.loading(false);
                this.error = rs.Error;
                if (rs.Error != "") {
                    this.showModal({ isShow: true, title: 'Error', content: rs.Error, type: 'error' });
                    //no permission
                    if (rs.Error.includes("Permission Denied")) {
                        window.history.back();
                    }
                } else {
                    this.showToast({ isShow: true, title: '', content: 'Edit user setting successfull', type: 'success' });
                }
            }
        },

        mounted() {
            //if already login then start,
            //else will watch isCheckedLogin to catch its change
            //to call start function
            if (this.isCheckedLogin) this.start();


        },
        watch: {
            //catch status from not login to logged in
            //to call start function.
            //Apply for reload page issue
            isCheckedLogin(newVal) {
                if (newVal) {
                    this.start();
                }
            }
        }

    };
</script>
